export const convertYoutubeShortsToWatch = (url) => {
    if (url.includes("youtube.com/shorts/")) {
        const shortsMatch = url.match(/youtube\.com\/shorts\/([a-zA-Z0-9_-]+)/);
        if (shortsMatch && shortsMatch[1]) {
            const videoId = shortsMatch[1];
            return `https://www.youtube.com/watch?v=${videoId}`;
        }
    }
    return url;
}

export const transformVideoUrl = (url, useDefault) => {
    console.log("useDefault value: ", useDefault);
    console.log("URL before transformation: ", url);

    // let transformedUrl = convertYoutubeShortsToWatch(url);

    if (useDefault) {
        console.log("Using original URL", url);
        return url;
    }
    console.log("Using CloudFront URL");
    return url.replace(
        "https://ceimages.s3.amazonaws.com/",
        "https://d22uqmtf5jk3kz.cloudfront.net/",
    );
};

export const formatFileSize = (bytes) => {
    if (bytes === 0) return "0 Bytes";

    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};



